type DetermineShouldSkip = {
  existingData?: LaunchPanelResponse;
  sessionActiveTab: SessionActiveTab;
};

export const determineShouldSkip = ({
  existingData,
  sessionActiveTab,
}: DetermineShouldSkip) =>
  existingData !== undefined || sessionActiveTab !== 'launchPanel';
